import React from 'react';
import {
	NavLink, Link
} from "react-router-dom";
import OrgSelect from './OrgSelect.js';
import WebPubLogo from '../Images/WebPub-logo.svg';

// Top level component for page
class LandingPage extends React.Component {
	
	render() {
		if (!this.props.userData || !this.props.logoutFn || !this.props.orgChangeFn || !this.props.activeOrg || !this.props.orgList) {
			return <div>Something went wrong. Please reload the page. (LP13)</div>;
		}
		
		const adminOrgs = this.props.userData.permissions.map((org) => {
			if (org.accessLevel >= 2) { // 0 is no access, 1 is read/submit, 2 is admin, 3 is a super-admin
				return parseInt(org.organizationId);
			}
			else {
				return null;
			}
		}).filter(item => item !== null);
		
		return (
			<div>
				<MenuHeader 
					userData={this.props.userData} 
					logoutFn={this.props.logoutFn} 
					orgChangeFn={this.props.orgChangeFn} 
					activeOrg={this.props.activeOrg} 
					orgList={this.props.orgList} 
					userId={this.props.userData.id} 
				/>
				<div className="title-bar">
					<NavLink to="/masterpool" className="nav-button" activeClassName='active'>Publication Pool</NavLink>
					<NavLink 
						to="/new" 
						className="nav-button" 
						activeClassName='active'
						isActive={newPubActiveCheck}
					>
						New Publication
					</NavLink>
					<NavLink to="/preview" className="nav-button" activeClassName='active'>Webpage Display</NavLink>
					{ // Only display org admin link if user is an admin for this org
						adminOrgs.includes(parseInt(this.props.activeOrg))
							? <NavLink 
								to="/organizations" 
								className="nav-button" 
								activeClassName='active'
								isActive={organizationsActiveCheck}
							>
								Organization Setup
							</NavLink>
							: null
					}
				</div>
			</div>
		)
	}
};
export default LandingPage;

class MenuHeader extends React.Component {
  render() {
	return (
	  <header className="app-menu-header">
		<Link to='/masterpool'>
			<img src={WebPubLogo} alt="logo" style={{ height: 135, paddingTop: 10, float: 'left' }} />
		</Link>
		<span className="signout-right">
			<div className="auth-button">
				Logged in as {" "}
				<NavLink to="/prefs" style={{ color: "rgb(14, 118, 188)", cursor: "pointer", textTransform: 'capitalize' }}>
					{this.props.userData.firstName + ' ' + this.props.userData.lastName}
				</NavLink>, {" "}
				<Link to="/" style={{ color: "rgb(14, 118, 188)", cursor: "pointer" }} onClick={this.props.logoutFn} >Sign Out</Link>
			</div>
			<OrgSelect 
				orgChangeFn={this.props.orgChangeFn} 
				setDefault="false" 
				selectedOrg={this.props.activeOrg} 
				orgList={this.props.orgList} 
				userId={this.props.userData.id} 
			/>
		</span>
	  </header>
	);
  }
};

// Determine if Organization Setup button should have the active class
const organizationsActiveCheck = (match, location) => {
	if (match) {
		return true;
	}
	else {
		return (location.pathname === '/users');
	}
};

const newPubActiveCheck = (match, location) => {
	if (match) { // exactly matches the NavLink's to prop
		return true;
	}
	else { // Matches other destinations we want to highlights
		return (location.pathname === '/edit');
	}
};

